var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglishUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_15717)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1108_15717",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 18,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 4.16663H3.25429C2.37765 4.16663 1.66699 4.86307 1.66699 5.72218V14.2777C1.66699 15.1368 2.37765 15.8333 3.25429 15.8333H16.7464C17.623 15.8333 18.3337 15.1368 18.3337 14.2777V5.72218C18.3337 4.86307 17.623 4.16663 16.7464 4.16663Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1108_15717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 4.16663H3.25429C2.37765 4.16663 1.66699 4.86307 1.66699 5.72218V14.2777C1.66699 15.1368 2.37765 15.8333 3.25429 15.8333H16.7464C17.623 15.8333 18.3337 15.1368 18.3337 14.2777V5.72218C18.3337 4.86307 17.623 4.16663 16.7464 4.16663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 4.16663H8.80985V9.61107H1.66699V4.16663Z",
    fill: "#444379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46094 4.94446V5.72224H3.25459V4.94446H2.46094ZM4.04824 4.94446V5.72224H4.84189V4.94446H4.04824ZM5.63554 4.94446V5.72224H6.42919V4.94446H5.63554ZM7.22284 4.94446V5.72224H8.01649V4.94446H7.22284ZM6.42919 5.72224V6.50001H7.22284V5.72224H6.42919ZM4.84189 5.72224V6.50001H5.63554V5.72224H4.84189ZM3.25459 5.72224V6.50001H4.04824V5.72224H3.25459ZM2.46094 6.50001V7.27779H3.25459V6.50001H2.46094ZM4.04824 6.50001V7.27779H4.84189V6.50001H4.04824ZM5.63554 6.50001V7.27779H6.42919V6.50001H5.63554ZM7.22284 6.50001V7.27779H8.01649V6.50001H7.22284ZM2.46094 8.05557V8.83335H3.25459V8.05557H2.46094ZM4.04824 8.05557V8.83335H4.84189V8.05557H4.04824ZM5.63554 8.05557V8.83335H6.42919V8.05557H5.63554ZM7.22284 8.05557V8.83335H8.01649V8.05557H7.22284ZM6.42919 7.27779V8.05557H7.22284V7.27779H6.42919ZM4.84189 7.27779V8.05557H5.63554V7.27779H4.84189ZM3.25459 7.27779V8.05557H4.04824V7.27779H3.25459Z",
    fill: "#A7B6E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80985 4.16663V4.9444H18.3337V4.16663H8.80985ZM8.80985 5.72218V6.49996H18.3337V5.72218H8.80985ZM8.80985 7.27774V8.05552H18.3337V7.27774H8.80985ZM8.80985 8.83329V9.61107H18.3337V8.83329H8.80985ZM1.66699 10.3888V11.1666H18.3337V10.3888H1.66699ZM1.66699 11.9444V12.7222H18.3337V11.9444H1.66699ZM1.66699 13.5V14.2777H18.3337V13.5H1.66699ZM1.66699 15.0555V15.8333H18.3337V15.0555H1.66699Z",
    fill: "#ED4C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.746 4.55554H3.25395C2.59647 4.55554 2.06348 5.07788 2.06348 5.72221V14.2778C2.06348 14.9221 2.59647 15.4444 3.25395 15.4444H16.746C17.4035 15.4444 17.9365 14.9221 17.9365 14.2778V5.72221C17.9365 5.07788 17.4035 4.55554 16.746 4.55554Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_15717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 11.6667,
    fill: "white",
    transform: "translate(1.66699 4.16663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishUs);
export default __webpack_public_path__ + "static/media/English(US).2434196c1869da18b9780ea7d52f1167.svg";
export { ForwardRef as ReactComponent };